<template>
<div class="chapter">
<div class="inner_page">
<div class="titlepage">
<p class="right" id="tp"><a id="page5"></a><span class="big1"><strong>Hold the Dream</strong></span><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/></p>
<p class="right">Barbara Taylor Bradford</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780795338557_epub_tp_r1.vue?831ac1ac